import { ClientSideError, ClientSideErrorType, logger } from '@dtx-company/logger'
import { PaymentMethod } from '@stripe/stripe-js'
import { SUBSCRIPTION_SERVICE_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'
import { flowFetch } from '@app/code/src/utils/flowFetch'
import { getRequestHeadersWithAuthHeader } from '../../components/org/utils'

export const getPaymentMethodUrl = (paymentMethodId: string): string =>
  `${SUBSCRIPTION_SERVICE_ENDPOINT}/v3/stripe/customers/payment_methods/${paymentMethodId}`

export interface GetPaymentMethodV3Args {
  token?: string
  paymentMethodId: string
}

export interface GetPaymentMethodV3Response {
  stripePaymentMethod: PaymentMethod
  message: string
}

export const getPaymentMethodV3 = async (
  arg?: GetPaymentMethodV3Args
): Promise<PaymentMethod | undefined> => {
  if (!arg || !arg.paymentMethodId || !arg.token) {
    const error = new ClientSideError({
      message: `Missing arguments token: ${arg?.token} paymentMethodId: ${arg?.paymentMethodId}`,
      type: ClientSideErrorType.ClientSideValidationError,
      name: 'getPaymentMethodV3'
    })
    logger.logError(error, { technicalArea: 'monetization' })
  } else {
    const headers = getRequestHeadersWithAuthHeader(arg.token)
    const res = await flowFetch<GetPaymentMethodV3Response>(
      'GET',
      getPaymentMethodUrl(arg.paymentMethodId),
      { technicalArea: 'monetization' },
      {
        headers
      }
    )
    return res?.data.stripePaymentMethod
  }
}
